import { useNavigation } from '@react-navigation/native'
import React from 'react'

import { EmojiButton } from 'pages/CreatePostModal/subcomponents/EmojiButton'

import { BottomSheetNavbar } from 'partials/BottomSheetNavbar'

import { Box } from 'widgets/Box'

import { useActivityTypes } from 'hooks/useActivityTypes'
import { useNavigateBackOrHome } from 'hooks/useNavigateBackOrHome'

import { links } from 'utils/constants'

import { useCreatePostModal } from 'contexts/CreatePostModalContext'

export const ActivityGroupSelection = () => {
  const navigation = useNavigation<any>()
  const createPostModalRef = useCreatePostModal()
  const navigateBackOrHome = useNavigateBackOrHome()
  const { types: activityTypes } = useActivityTypes()

  return (
    <Box
      testID='ActivityGroupSelectionPage'
      flexDirection='column'
      backgroundColor='white'
      flex={1}
    >
      <BottomSheetNavbar
        title='Select Activity Type'
        onBack={() => {
          createPostModalRef?.current?.collapse()
          navigateBackOrHome()
        }}
      />

      <Box testID='CreatePostTypeGroups'>
        <Box flexDirection='row' align='center' justifyContent='center'>
          <EmojiButton
            emoji='🏋🏻‍♂️'
            isSingleRow={false}
            title={activityTypes?.workout?.name}
            onPress={() => {
              navigation.navigate(links.ACTIVITY_TYPE_SELECTION_PAGE, {
                selectedGroup: activityTypes.workout.name,
              })
            }}
          />
          <EmojiButton
            emoji='‍🤾🏽‍♀️'
            isSingleRow={false}
            title={activityTypes?.sport?.name}
            onPress={() => {
              navigation.navigate(links.ACTIVITY_TYPE_SELECTION_PAGE, {
                selectedGroup: activityTypes.sport.name,
              })
            }}
          />
        </Box>
        <Box padding={{ top: 'sm' }} flexDirection='row' align='center' justifyContent='center'>
          <EmojiButton
            emoji='🧖🏽‍♀️️'
            isSingleRow={false}
            title={activityTypes?.recovery?.name}
            onPress={() => {
              navigation.navigate(links.ACTIVITY_TYPE_SELECTION_PAGE, {
                selectedGroup: activityTypes.recovery.name,
              })
            }}
          />
          <EmojiButton
            emoji='🧘🏽‍♂️'
            isSingleRow={false}
            title={activityTypes?.mindfulness?.name}
            onPress={() => {
              navigation.navigate(links.ACTIVITY_TYPE_SELECTION_PAGE, {
                selectedGroup: activityTypes.mindfulness.name,
              })
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}
